export const INITIALISE_SETTINGS_COMPLETE = 'INITIALISE_SETTINGS_COMPLETE';
export const INITIALISE_SETTINGS_ERROR = 'INITIALISE_SETTINGS_ERROR';

export const LOAD_SYNONYMS_COMPLETE = 'LOAD_SYNONYMS_COMPLETE';
export const LOAD_SYNONYMS_ERROR = 'LOAD_SYNONYMS_ERROR';

import { SETTINGS } from '../../../config';
import { initialiseFilters } from '.';
import { GetSynonyms } from '../api';

export function initialiseSettings(
	appId, groups, auth, microsite, showcaseCollection, 
	companyName, certificationFilter, baseUri, jobListingPageUrl, 
	freeTrialExpired, popularSearches, pressReleasesBaseUri, eventsBaseUri, insightsBaseUri ) 
	{
	return async(dispatch) => {
		let settings = SETTINGS[appId];	
		if (settings) {
			if (groups && auth) {
				settings.groups = groups;
				settings.isAuth = auth;
			}

			// settings.microsite = microsite || "";
			// settings.showcaseCollection = showcaseCollection || "";
			// settings.companyName = companyName || "";
			// settings.certificationFilter = certificationFilter || "";
			// settings.baseUri = baseUri || "";
			// settings.jobListingPageUrl = jobListingPageUrl || "";
			// settings.freeTrialExpired = freeTrialExpired || false;
			// settings.popularSearches = popularSearches || "";
			// settings.pressReleasesBaseUri = pressReleasesBaseUri || "";
			// settings.eventsBaseUri = eventsBaseUri || "";
			// settings.insightsBaseUri = insightsBaseUri || "";

			settings.microsite = "";

			if (microsite)
			{
				settings.microsite = microsite;
			}

			if (showcaseCollection)
			{
				settings.showcaseCollection = showcaseCollection;
			}

			if (companyName)
			{
				settings.companyName = companyName;
			}

			if (certificationFilter)
			{
				settings.certificationFilter = certificationFilter;
			}

			if (baseUri)
			{
				settings.baseUri = baseUri;
			}

			if(jobListingPageUrl)
			{
				settings.jobListingPageUrl = jobListingPageUrl;
			}

			if(freeTrialExpired)
			{
				settings.freeTrialExpired = freeTrialExpired;
			}

			if(popularSearches)
			{
				settings.popularSearches = popularSearches;
			}
			
			if(pressReleasesBaseUri)
			{
				settings.pressReleasesBaseUri = pressReleasesBaseUri;
			}

			if(eventsBaseUri)
			{
				settings.eventsBaseUri = eventsBaseUri;
			}

			if(insightsBaseUri)
			{
				settings.insightsBaseUri = insightsBaseUri;
			}


			dispatch(initialiseSettingsComplete(settings));
			dispatch(initialiseFilters(settings));
		}
		else {
			let errorMessage = 'Settings not found';
			// eslint-disable-next-line no-console
			console.log(errorMessage);
			dispatch(initialiseSettingsError(errorMessage));
		}	
	};
}

export function initialiseSettingsComplete(settings) {
	return {
		type: INITIALISE_SETTINGS_COMPLETE,
		settings
	};
}

export function initialiseSettingsError(error) {
	return {
		type: INITIALISE_SETTINGS_ERROR,
		error
	};
}


export function loadSynonyms() {
	return async(dispatch) => {
		let synonyms = await GetSynonyms();
		if (synonyms) {
			dispatch(loadSynonymsComplete(synonyms));
		}	
		else {
			let errorMessage = 'Synonyms not found';
			// eslint-disable-next-line no-console
			console.log(errorMessage);
			dispatch(loadSynonymsError(errorMessage));
		}	
	};
}
export function loadSynonymsComplete(synonyms) {
	return {
		type: LOAD_SYNONYMS_COMPLETE,
		synonyms
	};
}

export function loadSynonymsError(error) {
	return {
		type: LOAD_SYNONYMS_ERROR,
		error
	};
}

